import { LanguageCode } from '@cms-max/medicare-api-sdk'

const appBasePath = process.env.REACT_APP_BASEPATH ?? ''

// Since we're using relay param, this can be just base path
const getRedirectUri = () => {
  const url = new URL(window.location.href)
  return `${url.origin}${appBasePath}`
}

// This will get appended to the redirect URI
const getRelayParam = (redirectPath?: string) => {
  const url = new URL(window.location.href)
  if (redirectPath) {
    return `${redirectPath}${url.search}`
  }
  return url.pathname.replace(appBasePath, '') + url.search
}

export function buildLoginUrl (language: LanguageCode, redirectPath?: string): string {
  const url = new URL(`https://${process.env.REACT_APP_MEDICARE_ENV}.medicare.gov/account/login`)

  const paramTuples: [string, string][] = [
    ['client_id', 'max'],
    ['redirect_uri', getRedirectUri()],
    ['relay', getRelayParam(redirectPath)],
    ['lang', language === 'es' ? 'es-mx' : 'en-us']
  ]

  paramTuples.forEach(paramTuple => {
    url.searchParams.append(paramTuple[0], paramTuple[1])
  })

  return url.toString()
}
